import React from "react";

import destination_1 from "../../public/wheretogo-beskydy/velkyjavornik/destination_1.png";
import destination_2 from "../../public/wheretogo-beskydy/velkyjavornik/destination_2.png";
import destination_3 from "../../public/wheretogo-beskydy/velkyjavornik/destination_3.png";
import destination_4 from "../../public/wheretogo-beskydy/velkyjavornik/destination_4.png";
import destination_5 from "../../public/wheretogo-beskydy/velkyjavornik/destination_5.png";

import destinationIcon_1 from "../../public/wheretogo-beskydy/velkyjavornik/icon_1.png";
import destinationIcon_2 from "../../public/wheretogo-beskydy/velkyjavornik/icon_2.png";
import destinationIcon_3 from "../../public/wheretogo-beskydy/velkyjavornik/icon_3.png";
import destinationIcon_4 from "../../public/wheretogo-beskydy/velkyjavornik/icon_4.png";

import { useContext } from "react";
import { DarkModeContext } from "../../components/DarkModeProvider";

const VelkyJavornik = () => {
  const { darkMode } = useContext(DarkModeContext);

  return (
    <>
      <section className={`destinations ${darkMode ? "dark" : "light"}`}>
        <div class="container">
          <div class="destinations__container">
            <img src={destination_1} alt="" />
            <h1>Velký Javorník</h1>
            <p>
              Velký Javorník je hora v podhůří Beskyd, nejvyšší bod Veřovických
              vrchů. Hora je známé turistické místo s výhledem do širokého
              okolí, na vrcholu stojí turistická chata z roku 1935, která je
              otevřena celoročně, ale neposkytuje ubytování.
            </p>
          </div>
        </div>
      </section>

      <section className={`destinations__icons ${darkMode ? "dark" : "light"}`}>
        <div class="container">
          <div class="destinations__icons--container">
            <div class="destinations__icon">
              <img src={destinationIcon_1} alt="" />
              <p>rozhledna</p>
            </div>
            <div class="destinations__icon">
              <img src={destinationIcon_2} alt="" />
              <p>turistická chata</p>
            </div>
            <div class="destinations__icon">
              <img src={destinationIcon_3} alt="" />
              <p>918 m. n. m.</p>
            </div>
            <div class="destinations__icon">
              <img src={destinationIcon_4} alt="" />
              <p>výhled na beskydy</p>
            </div>
          </div>
        </div>
      </section>

      <section
        className={`destinations__attractions ${darkMode ? "dark" : "light"}`}
      >
        <div class="container">
          <div class="destinations__attractions--container">
            <div class="destinations__attractions--image">
              <img class="destination_1" src={destination_2} alt="" />
              <img class="destination_2" src={destination_3} alt="" />
              <img class="destination_3" src={destination_4} alt="" />
              <img class="destination_4" src={destination_5} alt="" />
            </div>
            <div class="destinations__attractions--content">
              <h2>Zajímavosti</h2>
              <ul>
                <li>
                  První horská chata byla na Velkém Javorníku postavena již roku
                  1895
                </li>
                <li>
                  Na vrcholu byla také postavena rozhledna už v roce 1934
                  (původně se jednalo o triangulační věž). Jednalo se o třináct
                  metrů vysokou dřevěnou věž postavenou v roce 1929 pro potřeby
                  Zeměmeřičského úřadu a upravenou do podoby rozhledny v roce
                  1934. Odstraněna byla v roce 1967 kvůli havarijnímu stavu.
                </li>
                <li>
                  Na jaře roku 2012 oznámil státní podnik Lesy České Republiky
                  svůj záměr postavit na vrcholu Javorníku rozhlednu. Rozhledna
                  byla dokončena v červenci a otevřena 15. srpna 2013.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default VelkyJavornik;
